export type AppLanguageCode = 'de' | 'en' | 'tr';

export interface AppLanguageOption {
  code: AppLanguageCode;
  flag: string;
  name: string;
}

export const APP_LANGUAGE_OPTIONS: readonly AppLanguageOption[] = [
  { code: 'de', flag: '🇦🇹', name: 'Deutsch' },
  { code: 'en', flag: '🇬🇧', name: 'English' },
  { code: 'tr', flag: '🇹🇷', name: 'Türkçe' }
];

export function normalizeAppLanguage(language: string | null | undefined): AppLanguageCode {
  const normalizedLanguage = language?.trim().toLowerCase().replace('_', '-');

  if (!normalizedLanguage) {
    return 'en';
  }

  if (normalizedLanguage === 'de' || normalizedLanguage.startsWith('de-')) {
    return 'de';
  }

  if (normalizedLanguage === 'tr' || normalizedLanguage.startsWith('tr-')) {
    return 'tr';
  }

  if (normalizedLanguage === 'en' || normalizedLanguage.startsWith('en-')) {
    return 'en';
  }

  return 'en';
}

export function getLanguageOption(language: string): AppLanguageOption {
  const normalizedLanguage = normalizeAppLanguage(language);
  return APP_LANGUAGE_OPTIONS.find(option => option.code === normalizedLanguage) ?? APP_LANGUAGE_OPTIONS[1];
}
